import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

export default function EditPaymentModel({opens,setOpens}) {
  console.log(opens)
    const [error, setErrors] = React.useState({});
    let [fieldsUser,setfieldsUser] = React.useState({})
    let handleChange = (e)=>{
        let {name,value} = e.target
        console.log(name,value)
    }
    const handleOpen = () => setOpens(true);
    const handleClose = () => setOpens(false);


  return (
    <div>
 
      <Modal
        open={opens}
       
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>

        <Box className='bg-[#005F60] mb-2 rounded-xl flex justify-between items-center '>
            <Box className="px-3 py-2 text-white font-bold" >Edit Payment</Box>
            <Box className="px-3 py-2 text-white font-bold"><CloseRoundedIcon onClick={handleClose} className=" cursor-pointer text-white font-bold" /></Box>
          </Box>


          <div>
                  <label htmlFor="name" className="block text-sm font-medium text-gray-700">
                   Name
                  </label>
                  <input
                    id="name"
                    name="name"
                    type="text"
                    placeholder="Enter Mobile Number"
                    className={`mt-1 p-2 w-full rounded-md border ${error.name ? 'border-red-500' : 'border-gray-300'
                      } focus:outline-none focus:border-blue-500`}
                      value={fieldsUser.name}
                      onChange={handleChange}
                  />
                  {error['name'] && <p className='text-sm text-red-500'>{error.name}</p>}
                </div>




                <div>
                  <label htmlFor="date" className="block text-sm font-medium text-gray-700">
                   Date
                  </label>
                  <input
                    id="date"
                    name="name"
                    type="date"
                    placeholder="Enter Mobile Number"
                    className={`mt-1 p-2 w-full rounded-md border ${error.date ? 'border-red-500' : 'border-gray-300'
                      } focus:outline-none focus:border-blue-500`}
                    value={fieldsUser.date}
                    onChange={handleChange}
                  />
                  {error['date'] && <p className='text-sm text-red-500'>{error.date}</p>}
                </div>



                <div>
                  <label htmlFor="description" className="block text-sm font-medium text-gray-700">
                   
                   Description
                  </label>
                  <input
                    id="description"
                    name="description"
                    type="text"
                    placeholder="Enter Mobile Number"
                    className={`mt-1 p-2 w-full rounded-md border ${error.description ? 'border-red-500' : 'border-gray-300'
                      } focus:outline-none focus:border-blue-500`}
                    value={fieldsUser.description}
                    onChange={handleChange}
                  />
                  {error['description'] && <p className='text-sm text-red-500'>{error.description}</p>}
                </div>




                <div>
                  <label htmlFor="amount" className="block text-sm font-medium text-gray-700">
                   
                   Amount
                  </label>
                  <input
                    id="amount"
                    name="amount"
                    type="text"
                    placeholder="Enter Mobile Number"
                    className={`mt-1 p-2 w-full rounded-md border ${error.amount ? 'border-red-500' : 'border-gray-300'
                      } focus:outline-none focus:border-blue-500`}
                    value={fieldsUser.amount}
                    onChange={handleChange}
                  />
                  {error['amount'] && <p className='text-sm text-red-500'>{error.amount}</p>}
                </div>


                <div>
                  <label htmlFor="image" className="block text-sm font-medium text-gray-700">
                   
                   Image
                  </label>
                  <input
                    id="image"
                    name="image"
                    type="file"
                    placeholder="Enter Mobile Number"
                    className={`mt-1 p-2 w-full rounded-md border ${error.image ? 'border-red-500' : 'border-gray-300'
                      } focus:outline-none focus:border-blue-500`}
                    value={fieldsUser.image}
                    onChange={handleChange}
                  />
                  {error['image'] && <p className='text-sm text-red-500'>{error.image}</p>}
                </div>



                <Box className="px-3 py-2 rounded mt-2 cursor-pointer bg-[#005F60] text-white text-center font-bold" >Submit  </Box>
           

           


        </Box>
      </Modal>
    </div>
  );
}